import { styled, theme } from 'ui/theme';

export const HeaderOrderSuccess = {
  Component: styled.div`
    align-items: center;
    background-color: ${theme.colors.build.lightDark2};
    justify-content: center;
    display: flex;
    height: ${theme.sizes[18]};
  `,
};
